import { Container, Row, Col, ListGroup, Spinner } from 'react-bootstrap';
import FromPageIndicator from '../Common/FromPageIndicator';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

const CancerDetail = () => {
  const { cancerTypeId } = useParams();
  console.log(cancerTypeId);
  
  const [cancerDetail, setCancerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCancerDetail = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.dremerz.net/api/DZ_8921_TnpyAmpicon_Cancer_AddCancerDetail_CancerDetailList?cancerTypeId=${cancerTypeId}`
        );
        setCancerDetail(response.data[0]);
        console.log(response.data);
        setError(null);
      } catch (error) {
        console.error("Error fetching cancer details:", error);
        setError("Failed to load cancer details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (cancerTypeId) {
      fetchCancerDetail();
    }
  }, [cancerTypeId]);

  const imageBaseUrl = "https://api.dremerz.net/uploads";

  const getCancerTypes = (cancerDetail) => {
    if (!cancerDetail || !cancerDetail.cancerSymptoms) return [];
    
    try {
      const types = JSON.parse(cancerDetail.cancerSymptoms);
      return types.filter(type => type.trim() !== "");
    } catch (error) {
      console.error("Error parsing cancer types:", error);
      return [];
    }
  };

  if (loading) {
    return (
      <>
        {/* <FromPageIndicator /> */}
        <div className="text-center py-5">
          <Spinner animation="border" role="status" variant="info">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading cancer details...</p>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        {/* <FromPageIndicator /> */}
        <div className="text-center py-5 text-danger">
          <p>{error}</p>
        </div>
      </>
    );
  }

  if (!cancerDetail) {
    return (
      <>
        {/* <FromPageIndicator /> */}
        <div className="text-center py-5">
          <p>No cancer information found for this ID.</p>
        </div>
      </>
    );
  }

  const cancerTypes = getCancerTypes(cancerDetail);

  return (
    <>

      <div className="bg-white" style={{marginTop: "110px"}}>
        <div className="position-relative">
          <div
            style={{
              backgroundColor: "#0098b0",
              backgroundImage: "linear-gradient(135deg, #0098b0 0%, #006d80 100%)",
              height: "290px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              className="position-absolute"
              style={{
                backgroundImage: cancerDetail.image 
                  ? `url(${imageBaseUrl}/${cancerDetail.image})`
                  : "",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                width: "320px",
                height: "290px",
                left: 0,
              }}
            />
            <Container>
              <Row>
                <Col md={6} className="offset-md-2" style={{marginTop: "80px"}}>
                  <h1 className="text-white mt-5">{cancerDetail.cancerName || "Cancer Details"}</h1>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/* Main Content */}
        <Container className="py-4">
          <div className="pb-3 border-bottom border-info">
            <h2 className="text-info mt-3">{`${cancerDetail.cancerSubName}`}</h2>
          </div>

          <div className="py-4">
            <h3>Overview</h3>
            <p className="text-muted">
              {cancerDetail.cancerDescription || "No description available for this cancer type."}
            </p>
          </div>

          {cancerTypes.length > 0 && (
            <div className="py-2">
              <h3>Types of {cancerDetail.cancerName} Cancer:</h3>
              <ListGroup variant="flush" className="border-0">
                {cancerTypes.map((type, index) => (
                  <ListGroup.Item key={index} className="border-0 ps-4">
                    • {type}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          )}
        </Container>
      </div>
    </>
  );
};

export default CancerDetail;